<!-- Pug Template -->
<template lang="pug">
.tech-company-stage
	.tech-company-stage-heading.card.card--heading.p-4.align-items-start.text-white.mb-4.fade-down(
		:style="headerStyle"
		data-in-view
	)
		router-link.btn.btn-pill.btn-white.btn-outline.mb-3.font-sans.btn-lg(
			:to="{name: 'index'}"
		)
			span.mdi.mdi-arrow-left.mr-2
			| Back to all Stages
		.row.align-items-center.mx-n4
			.col-12.col-lg-auto.px-4
				h1.display-4.text-white.mb-0 0{{ stage.number}}. {{ stage.name }}
			.col.px-4.border-left
				.demargin.description(
					style="max-width: 50em"
					v-html="replaceVerticalText(stage.description, stage.topLevelVerticals)"
				)

	.tech-company-stage-verticals.row
		.col-sm-6.d-flex.mb-lg-4.mb-2(
			v-for="vertical in stage.topLevelVerticals"
			:key="vertical.id"
		)
			vertical-card(
				data-in-view
				:vertical="vertical"
			)
</template>

<!-- Script -->
<script>
import store from './store';
import {replaceVerticalText} from './store';
import VerticalCard from './VerticalCard.vue';
const $ = jQuery;
export default {
	components: { VerticalCard },
	props: {
		stage_slug: {
			type: String,
			required: true
		}
	},
	data(){
		return {
			boxes: $('.tech-company-boxes').first(),
			replaceVerticalText
		}
	},
	computed: {
		stage(){
			return store.stage(this.stage_slug );
		},
		headerStyle(){
			return {
				backgroundColor: this.stage.backgroundColor
			}
		}
	},
	mounted(){
		this.boxes.addClass('d-none');
	}
};
</script>

<!-- SCSS Style -->
<style lang="scss" scoped>
.description {
	font-size: 1.2rem;
	line-height: 1.75;
	font-weight: 300;
}
.border-left {
	@media (max-width: 991px){
		border-left-width: 0;
	}
}
</style>